import Landing from './LandingPage/LandingPage';

export default {
  LandingPage: Landing,
};
